import { getLastSyncTimeKey } from './const';
let contactSyncIntervalSeq = 10 * 6;
export const setContactSyncIntervalSeq = (minutes) => {
    if (minutes) {
        contactSyncIntervalSeq = minutes * 6 * 60;
    }
};
export const getContactSyncIntervalSeq = () => contactSyncIntervalSeq;
export const getStoreLastTime = async (lastTimeKey, context) => {
    const data = await context.store.get(getLastSyncTimeKey(lastTimeKey));
    return data.suc ? Number(data.data) : 0;
};
export const setStoreLastTime = (lastTimeKey, lastTime, context) => {
    return context.store.put(getLastSyncTimeKey(lastTimeKey), String(lastTime));
};
export const getStoreContactSyncPageInfo = async (params, context) => {
    var _a;
    const { from, domain, _account } = params;
    const accountMd5 = ((_a = context.systemApi.getCurrentUser(_account)) === null || _a === void 0 ? void 0 : _a.accountMd5) || '';
    try {
        const result = await context.taskApi.getContactSyncTask({
            from,
            domain,
            account: accountMd5,
        });
        const isExpired = result.expiredTime <= Date.now();
        if (!result) {
            return {
                domain,
                from,
                account: accountMd5,
                pageIndex: 0,
                totalPage: 0,
                lastMaxId: '',
                source: 'unknown',
            };
        }
        if (isExpired) {
            return Object.assign(Object.assign({}, result), { pageIndex: 0, totalPage: 0, lastMaxId: '', source: 'unknown' });
        }
        return result;
    }
    catch (ex) {
        return {
            domain,
            from,
            account: accountMd5,
            pageIndex: 0,
            totalPage: 0,
            lastMaxId: '',
            source: 'unknown',
        };
    }
};
export const setStoreContactSyncPageInfo = async (params, enableUseNewestTime = true, context) => {
    var _a;
    const { _account } = params;
    const accountMd5 = ((_a = context.systemApi.getCurrentUser(_account)) === null || _a === void 0 ? void 0 : _a.accountMd5) || '';
    const lastRecord = await context.taskApi.getContactSyncTask({
        account: accountMd5,
        domain: params.domain,
        from: params.from,
    });
    const increaseUpdateTimeRetryTimes = lastRecord.retryTimes || 0;
    if (!enableUseNewestTime && increaseUpdateTimeRetryTimes < 2) {
        Reflect.deleteProperty(params, 'lastUpdateTime');
        params.retryTimes = increaseUpdateTimeRetryTimes + 1;
    }
    if (params.step === 'all') {
        params.fullLastUpdateTime = params.lastUpdateTime;
        Reflect.deleteProperty(params, 'lastUpdateTime');
    }
    return context.taskApi.doUpdateContactSyncTask(Object.assign(Object.assign(Object.assign({}, lastRecord), params), { lastMaxId: params.lastMaxId, account: accountMd5 }));
};
export const getAccountSession = (account, context) => {
    const result = {
        _session: '',
        sid: '',
    };
    const accounts = context.accountApi.getLocalSubAccountsFromCache({
        subAccountEmail: account,
        expired: false,
    });
    const accountInfo = accounts.find((it) => it.id === account);
    if (accountInfo) {
        result._session = '';
        result.sid = accountInfo.sessionId;
    }
    return result;
};
export const retry = async (fn, count = 3) => {
    const tid = window.setTimeout(() => {
        if (count >= 1) {
            retry(fn, count - 1);
        }
    }, 3000 + (4 - count) * 2000);
    fn(tid);
};
